export default {"src":"/_next/static/media/dashboardSelectedIcon.52900085.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};